// Ensure a URL is absolute against the WordPress base (NEXT_PUBLIC_API_URL)

const API_ORIGIN = process.env.NEXT_PUBLIC_API_URL ?? "";

export function toAbsoluteUrl(url?: string | null | false): string | null {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("/")) {
    if (!API_ORIGIN) return url;
    const originUrl = new URL(API_ORIGIN);
    const originPath = originUrl.pathname.replace(/\/$/, "");
    if (originPath && url.startsWith(originPath + "/")) {
      return originUrl.origin + url;
    }
    return API_ORIGIN + url;
  }
  return url;
}